import { inputBackground, border, foreground } from './variables';

// Custom CSS styles for the react-select component

export const selectStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isDisabled ? '#aaa' : foreground,
    backgroundColor: inputBackground,
    padding: '0.2rem 0.4rem',
    fontSize: '0.8rem',
    fontWeight: state.isDisabled ? '300' : state.isSelected ? 'bold' : 'normal',
    cursor: 'pointer',
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: inputBackground,
    border: `1px solid ${border}`,
    borderRadius: '0',
    padding: '0',
    zIndex: '3',
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    color: foreground,
    backgroundColor: inputBackground,
    border: `1px solid ${border} !important`,
    boxShadow: 'none !important',
    borderRadius: '0',
    padding: '0',
    minHeight: '0'
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: foreground,
    fontSize: '0.8rem',
    padding: '0',
    margin: '0',
  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    padding: '0',
    margin: '-0.8rem 0 -0.8rem 0.3rem',
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    maxHeight: '1.3rem',
    padding: '0'
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    background: border,
    margin: '2px 2px 2px 2px',
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    margin: '0 2px 0 0',
  }),
};